<template>
  <v-layout
    justify-center
    align-center
    fill-height
    class="about-background"
    style="
      background-image: url(/images/background/fondo.jpg);
      width: 100% !important;
      min-height: 100vh;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      position: relative;
      z-index: 1;
      margin: 0 !important;
    "
  >
    <!-- Dark overlay -->
    <div class="about-overlay"></div>

    <!-- Top Bar Navigation -->
    <div class="top-nav">
      <v-btn rounded class="login-nav-btn" @click="loguearse()">
        <v-icon left>mdi-login-variant</v-icon>
        <span>Ingresar</span>
        <v-icon right small class="btn-arrow-icon">mdi-arrow-right</v-icon>
      </v-btn>
    </div>

    <v-container fluid fill-height text-center class="about-center-container">
      <v-layout align-center justify-center pa-4>
        <v-flex xl6 lg7 md8 sm10 xs12>
          <!-- Main Showcase Section (No card) -->
          <div class="showcase-content">
            <!-- Logo Section -->
            <div class="about-logo-wrapper">
              <img
                class="about-logo"
                src="/images/background/LOGO-PRINCIPAL-TIRESOFT.png"
                alt="TireSoft Logo"
              />
              <p class="about-subtitle">
                Plataforma de Análisis y Gestión de Neumáticos
              </p>
            </div>

            <!-- Modern Glassmorphism Feature Chips -->
            <div class="features-container">
              <div class="feature-chip">
                <div class="chip-icon-wrap">
                  <v-icon small color="#ff5252"
                    >mdi-chart-timeline-variant-shimmer</v-icon
                  >
                </div>
                <span>Análisis Predictivo</span>
              </div>
              <div class="feature-chip">
                <div class="chip-icon-wrap">
                  <v-icon small color="#ff5252">mdi-tire</v-icon>
                </div>
                <span>Gestión de Flota</span>
              </div>
              <div class="feature-chip">
                <div class="chip-icon-wrap">
                  <v-icon small color="#ff5252">mdi-shield-check</v-icon>
                </div>
                <span>Control de Calidad</span>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Version & Copyright in the bottom center of the web -->
    <div class="about-footer">
      <p class="version-label">
        Tiresoft.pe versión {{ appVersion }} ({{ appDate }})
      </p>
      <p class="copyright-label">
        © 2018-{{ currentYear }} Mandril S.A.C., empresa colaboradora de
        <!-- a href="https://reencauchadoraelsol.com" target="_blank">Reencauchadora El Sol</a -->
        <a href="https://tiresol.com.pe" target="_blank">Tiresol</a><br>
        Desarrollado por <a href="https://contentmedia.pe" target="_blank">Content Media</a>
      </p>
    </div>
  </v-layout>
</template>

<script>
import NavigationDrawer from "@/components/layout/NavigationDrawer.vue";
import NavigationDrawer2 from "@/components/layout/NavigationDrawer2.vue";
import global from "@/global";

export default {
  name: "AboutView",
  components: {
    NavigationDrawer,
    NavigationDrawer2,
  },
  data: () => ({
    isRegister: false,
    isCliente: localStorage.getItem("idcliente"),
    appVersion: global.app_version,
    appDate: global.app_build_date,
  }),
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  mounted() {
    this.isRegister = localStorage.getItem("logueo");
    this.isCliente = localStorage.getItem("idcliente");
  },
  created() {
    this.isRegister = localStorage.getItem("logueo");
  },
  methods: {
    loguearse: function () {
      this.$router.push({
        path: "/login",
      });
    },
  },
};
</script>

<style scoped>
/* ===== Dark Overlay ===== */
.about-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at center,
      rgba(15, 23, 42, 0.45) 0%,
      rgba(10, 15, 30, 0.75) 100%
    ),
    linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(15, 23, 42, 0.6) 100%);
  z-index: 0;
}

/* ===== Top Nav ===== */
.top-nav {
  position: absolute;
  top: 24px;
  right: 28px;
  z-index: 10;
}

.login-nav-btn {
  background: linear-gradient(
    135deg,
    #c62828 0%,
    #e53935 50%,
    #ff5252 100%
  ) !important;
  color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 28px !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  letter-spacing: 0.6px;
  text-transform: none;
  padding: 0 22px !important;
  height: 44px !important;
  box-shadow: 0 4px 20px rgba(229, 57, 53, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.15) inset !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.login-nav-btn .btn-arrow-icon {
  transition: transform 0.25s ease;
}

.login-nav-btn:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 8px 28px rgba(229, 57, 53, 0.7),
    0 0 0 1px rgba(255, 255, 255, 0.3) inset !important;
}

.login-nav-btn:hover .btn-arrow-icon {
  transform: translateX(4px);
}

.login-nav-btn:active {
  transform: translateY(0) scale(1);
}

/* ===== Center Showcase Section ===== */
.about-center-container {
  position: relative;
  z-index: 1;
}

.showcase-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px 10px;
}

/* ===== Logo Section ===== */
.about-logo-wrapper {
  margin-bottom: 32px;
}

.about-logo {
  width: 650px;
  max-width: 90vw;
  height: auto;
  margin-bottom: 18px;
  filter: drop-shadow(0 4px 18px rgba(0, 0, 0, 0.6))
    drop-shadow(0 0 10px rgba(255, 255, 255, 0.25));
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.about-logo:hover {
  transform: scale(1.03);
}

.about-subtitle {
  color: rgba(255, 255, 255, 0.85);
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7);
  margin-bottom: 0;
}

/* ===== Feature Chips ===== */
.features-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.feature-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 30px;
  padding: 8px 18px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.92);
  font-weight: 500;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
  user-select: none;
}

.chip-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 82, 82, 0.15);
}

.feature-chip:hover {
  background: rgba(229, 57, 53, 0.18);
  border-color: rgba(255, 82, 82, 0.45);
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(229, 57, 53, 0.3);
}

.feature-chip:hover .chip-icon-wrap {
  background: rgba(255, 82, 82, 0.3);
}

/* ===== Footer ===== */
.about-footer {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 2;
  padding: 0 16px;
}

.version-label {
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  margin-bottom: 2px;
  letter-spacing: 0.4px;
  font-weight: 500;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}

.copyright-label {
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  letter-spacing: 0.3px;
  font-weight: 400;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .about-logo {
    width: 340px;
  }

  .about-subtitle {
    font-size: 13px;
    letter-spacing: 0.8px;
  }

  .features-container {
    gap: 10px;
  }

  .feature-chip {
    font-size: 12px;
    padding: 6px 14px;
  }
}

@media (max-width: 600px) {
  .top-nav {
    top: 14px;
    right: 14px;
  }

  .login-nav-btn {
    height: 36px !important;
    padding: 0 14px !important;
    font-size: 12px !important;
    border-radius: 20px !important;
    letter-spacing: 0.3px !important;
  }

  .login-nav-btn .v-icon--left {
    margin-right: 4px !important;
    font-size: 16px !important;
  }

  .login-nav-btn .btn-arrow-icon {
    font-size: 14px !important;
    margin-left: 2px !important;
  }

  .about-center-container {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }

  .showcase-content {
    padding: 10px 6px !important;
  }

  .about-logo-wrapper {
    margin-bottom: 20px !important;
  }

  .about-logo {
    width: 230px !important;
    max-width: 82vw !important;
    margin-bottom: 12px !important;
  }

  .about-subtitle {
    font-size: 11px !important;
    letter-spacing: 0.5px !important;
    max-width: 290px;
    margin: 0 auto !important;
    line-height: 1.4 !important;
  }

  .features-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px !important;
    max-width: 320px;
    margin: 0 auto !important;
  }

  .feature-chip {
    font-size: 11px !important;
    padding: 5px 12px !important;
    gap: 6px !important;
    border-radius: 20px !important;
    letter-spacing: 0.2px !important;
  }

  .chip-icon-wrap {
    width: 20px !important;
    height: 20px !important;
  }

  .chip-icon-wrap >>> .v-icon {
    font-size: 13px !important;
  }

  .about-footer {
    bottom: 10px !important;
    padding: 0 10px !important;
  }

  .version-label {
    font-size: 10px !important;
  }

  .copyright-label {
    font-size: 9px !important;
  }
}

@media (max-width: 360px) {
  .top-nav {
    top: 10px;
    right: 10px;
  }

  .login-nav-btn {
    height: 32px !important;
    padding: 0 10px !important;
    font-size: 11px !important;
  }

  .about-logo {
    width: 190px !important;
  }

  .about-subtitle {
    font-size: 10px !important;
    max-width: 250px;
  }

  .feature-chip {
    font-size: 10.5px !important;
    padding: 4px 10px !important;
  }
}
</style>
